import { render, staticRenderFns } from "./mInfoList.vue?vue&type=template&id=4ce80663&scoped=true&"
import script from "./mInfoList.vue?vue&type=script&lang=js&"
export * from "./mInfoList.vue?vue&type=script&lang=js&"
import style0 from "./mInfoList.vue?vue&type=style&index=0&id=4ce80663&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce80663",
  null
  
)

export default component.exports